import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { articles } from '../../mocks/articles';

const LegalInsightsPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  const categories = ['Tümü', ...Array.from(new Set(articles.map((a) => a.category)))];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-navy-900">
        <div className="absolute inset-0 opacity-10">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C9A961' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          ></div>
        </div>
        <div className="relative max-w-[1200px] mx-auto px-6 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-block px-6 py-2 border border-gold-500 rounded-full mb-6">
              <span className="text-xs font-sans uppercase tracking-widest text-gold-500">HUKUKİ GÖRÜŞLER</span>
            </div>
            <h1 className="font-serif text-5xl lg:text-6xl text-white mb-6">
              Hukuki Bilgi<br />Merkezi
            </h1>
            <p className="font-sans text-lg text-white/80 max-w-3xl mx-auto leading-relaxed">
              Hukuk alanındaki güncel gelişmeler, uzman görüşleri ve pratik bilgiler
            </p>
          </motion.div>
        </div>
      </section>

      {/* Featured Article */}
      <section className="py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div {...fadeInUp}>
            <Link
              to={`/legal-insights/${articles[0].slug}`}
              className="group block cursor-pointer"
            >
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <div className="relative h-96 lg:h-auto overflow-hidden">
                  <img
                    src={articles[0].image}
                    alt={articles[0].title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-6 left-6">
                    <span className="px-4 py-2 bg-gold-500 text-white text-xs font-sans font-semibold uppercase tracking-wider rounded-full">
                      Öne Çıkan
                    </span>
                  </div>
                </div>
                <div className="p-8 lg:p-12 flex flex-col justify-center">
                  <div className="flex items-center space-x-4 mb-4">
                    <span className="px-3 py-1 bg-navy-900 text-white text-xs font-sans font-medium rounded-full">
                      {articles[0].category}
                    </span>
                    <span className="text-sm text-gray-500">{articles[0].date}</span>
                  </div>
                  <h2 className="font-serif text-3xl lg:text-4xl text-navy-900 mb-4 group-hover:text-gold-500 transition-colors">
                    {articles[0].title}
                  </h2>
                  <p className="font-sans text-base text-gray-600 leading-relaxed mb-6">
                    {articles[0].excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-gold-500 rounded-full flex items-center justify-center">
                        <span className="text-sm font-sans font-bold text-white">
                          {articles[0].author.split(' ').map(n => n[0]).join('')}
                        </span>
                      </div>
                      <div>
                        <div className="font-sans text-sm font-medium text-navy-900">{articles[0].author}</div>
                        <div className="font-sans text-xs text-gray-500">{articles[0].readTime} okuma</div>
                      </div>
                    </div>
                    <div className="inline-flex items-center text-gold-500 font-medium group-hover:translate-x-2 transition-transform">
                      <span>Devamını Oku</span>
                      <i className="ri-arrow-right-line ml-2"></i>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div {...fadeInUp} className="mb-12">
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map((category) => (
                <button
                  key={category}
                  className="px-6 py-2 bg-white border border-gray-300 text-navy-900 font-sans text-sm font-medium rounded-full hover:bg-navy-900 hover:text-white hover:border-navy-900 transition-all whitespace-nowrap cursor-pointer"
                >
                  {category}
                </button>
              ))}
            </div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.slice(1).map((article, index) => (
              <motion.div
                key={article.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <Link
                  to={`/legal-insights/${article.slug}`}
                  className="group block bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 h-full cursor-pointer"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 to-transparent"></div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center space-x-3 mb-3">
                      <span className="px-3 py-1 bg-gold-500/10 text-gold-500 text-xs font-sans font-medium rounded-full">
                        {article.category}
                      </span>
                      <span className="text-xs text-gray-500">{article.date}</span>
                    </div>
                    <h3 className="font-sans text-xl font-semibold text-navy-900 mb-3 line-clamp-2 group-hover:text-gold-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="font-sans text-sm text-gray-600 leading-relaxed mb-4 line-clamp-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                      <div className="flex items-center space-x-2">
                        <div className="w-8 h-8 bg-gold-500 rounded-full flex items-center justify-center">
                          <span className="text-xs font-sans font-bold text-white">
                            {article.author.split(' ').map(n => n[0]).join('')}
                          </span>
                        </div>
                        <span className="font-sans text-xs text-gray-600">{article.author}</span>
                      </div>
                      <span className="font-sans text-xs text-gray-500">{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-24 bg-navy-900">
        <div className="max-w-[800px] mx-auto px-6 lg:px-12 text-center">
          <motion.div {...fadeInUp}>
            <h2 className="font-serif text-4xl text-white mb-6">Hukuki Güncellemeler</h2>
            <p className="font-sans text-lg text-white/80 mb-10">
              Hukuk alanındaki güncel gelişmeler ve uzman görüşlerinden haberdar olmak için bültenimize abone olun
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-6 py-4 bg-white text-navy-900 rounded-md font-sans text-sm focus:outline-none focus:ring-2 focus:ring-gold-500"
              />
              <button className="px-8 py-4 bg-gold-500 text-white font-sans text-sm font-medium rounded-md hover:bg-gold-600 transition-colors whitespace-nowrap cursor-pointer">
                Abone Ol
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LegalInsightsPage;